(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zuitable-size-finder-inline"] && !Shopify.designMode) return;
  try {
    
(function(){
  function placeSizeFinder(){
    document.querySelectorAll('[data-zsf-inline-host]').forEach(function(host){
      var picker=document.querySelector('product-rerender variant-picker.product-form__variants')||document.querySelector('product-rerender variant-picker')||document.querySelector('variant-picker.product-form__variants')||document.querySelector('variant-picker');
      if(!picker||picker.contains(host))return;
      var firstOption=picker.querySelector('.product-form__option-selector');
      if(firstOption)picker.insertBefore(host,firstOption);else picker.appendChild(host);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',placeSizeFinder);else placeSizeFinder();
  document.addEventListener('shopify:section:load',placeSizeFinder);
})();

  } catch(e) { console.error(e); }
})();
})();
